<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="documentType.name"
          :counter="100"
          label="Name"
          :rules="nameRules"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="documentType.description"
          :counter="200"
          label="Description"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-switch
          v-model="documentType.expirationDateRequired"
          label="Expirationdate Required"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-switch
          v-model="documentType.validationRequired"
          label="Validation Required"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-switch
          v-model="documentType.limitIdentityEndDateToDocumentValidity"
          label="Limit IdentityEndDate to DocumentValidity"
        ></v-switch>
      </v-col>
      <v-col cols="12">
        <v-btn class="ma-2" color="success" @click="submit">save</v-btn>
        <v-btn class="ma-2" color="primary" @click="back">back</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: ["me", "documentType"],
  data: () => ({
    submitStatus: null,
    valid: false,
    nameRules: [
      v => !!v || "This field is required",
      v => (v && v.length <= 100) || "100 characters maximum"
    ]
  }),
  computed: {
  },
  methods: {  
    fieldRules(field) {
      if (!field.isRequired) return [];
      else {
        return [v => !!v || field.name + " is required"];
      }
    },
    submit() {
      if (!this.$refs.form.validate()) {
        this.submitStatus = "ERROR";
      } else {
        if (
          this.documentType.id == undefined ||
          this.documentType.id == "00000000-0000-0000-0000-000000000000"
        ) {
          delete(this.documentType.id);
          this.submitStatus = "POSTING";
          this.$http
            .post("api/documentTypes/", this.documentType)
            .then(request => {
              if (request.status == 201) {
                this.$emit("done");
                this.submitStatus = "";
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch(e => {
              this.$root.$children[0].$emit("display-error", "3000", e);
              this.submitStatus = "ERROR";
            });
        } else {
          this.submitStatus = "PUTTING";
          this.$http
            .put("api/documentTypes/" + this.documentType.id, this.documentType)
            .then(request => {
              if (request.status == 201) {
                this.$emit("done");
              } else {
                this.submitStatus = "ERROR";
              }
            })
            .catch(e => {
              this.$root.$children[0].$emit("display-error", "3001", e);
              this.submitStatus = "ERROR";
            });
        }
      }
    },
    back() {
      this.$emit("done");
    },
  }
};
</script>